import Form from "ui/common/components/input/Form/Form";
import useTranslate from "ui/locale/hooks/useTranslate";
import { AddPointFormData, AddPointFormDataKeys, AddPointModalProps } from "./AddPointsModal.types";
import clsx from "clsx";
import useAddPoint from "features/points/hooks/useAddPoint";
import { createModal, useModal, useToast } from "@commonlibs";
import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import Modal from "ui/common/components/feedback/Modal/Modal";
import PointsBalanceField from "ui/wallet/component/input/PointsBalanceField/PointsBalanceField";
import useVerifyReleaseStrategyMethod from "ui/release-strategy/hooks/useVerifyReleaseStrategyMethod";
import { Operations } from "ui/admins/operations.types";

const AddPointsModal = createModal(({ className, ...rest }: AddPointModalProps) => {
    const translate = useTranslate();
    const { showToast } = useToast();
    const { hideModal } = useModal();
    const { mutate: addPoint, isLoading } = useAddPoint({ onSuccess: handleSuccess });
    const { verifyReleaseMethod, isValidatingReleaseStrategy } = useVerifyReleaseStrategyMethod({
        onSuccess: handleSuccess,
        isLoading,
    });

    function handleSuccess() {
        showToast(translate("addPointSuccess"), { type: "success" });
        hideModal(AddPointsModal.id);
    }

    function handleSubmit({ amount }: AddPointFormData) {
        const executeAction = (...args: unknown[]) => {
            const [pointData] = args as [{ amount: string }];
            addPoint(pointData);
        };

        verifyReleaseMethod({
            originalFn: executeAction,
            originalArgs: [{ amount }],
            operationTypeId: Operations.MINT_POINTS_TO_MAIN_WALLET,
        });
    }

    return (
        <Modal className={clsx("add-points-modal", className)} title={translate("addPoints")} {...rest}>
            <Form className={clsx("add-points", className)} onSubmit={handleSubmit}>
                <PointsBalanceField name={AddPointFormDataKeys.amount} required label={translate("quantity")} validators={{ gt: "0" }} />
                <ModalFooter
                    mainType="submit"
                    mainLabel={translate("add")}
                    isLoading={isLoading || isValidatingReleaseStrategy}
                    onCancel={() => hideModal(AddPointsModal.id)}
                />
            </Form>
        </Modal>
    );
});

export default AddPointsModal;
